export default __webpack_public_path__ + "static/media/success.ca5099ba.svg";